<div class="container">
  <form [formGroup]="ebForm">

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="queryId">COUNTRY</label>
          <select2 [data]="countries" [value]="selectedCountry" [templates]="template" class="select2" (update)="onCountryChange($event)">
            <ng-template #template let-data="data" let-label="label">
              <div class="country-container">
                <div *ngIf="data?.image">
                  <img [src]="data.image" alt="{{ label }}" />
                </div>
                <span>{{ label }}</span>
              </div>
            </ng-template>
          </select2>
        </div>
      </div>

      <div class="col-md-8" *ngIf="requirementIds">
        <div class="form-group">
          <label for="requirementId">REQUIREMENT ID</label>
          <select2 [data]="requirementIds" (update)="onRequirementChange($event)"></select2>
        </div>
      </div>

    </div>

    <div *ngIf="ebForm.value">
      <label for="query">Query</label>
      <pre>{{ ebForm.value | json }}</pre>
    </div>

    <div *ngIf="response">
      <label for="response">Response</label>
      <pre>{{ response | json }}</pre>
    </div>

  </form>

</div>